<template>
  <div>
    <Modal
      v-model="appointModal"
      title="受理"
      @on-cancel="cancelModal">
      <Form :models="form" :label-width="60" ref="form">
        <FormItem label="问题分类" prop="type">
          <Select v-model="form.type" @on-change="handleTypeOnChange" placeholder="请选择指派目标问题分类">
            <Option v-for="item in workSheetTypeList" :key="item.id" :value="item.id" :label="item.type_name"></Option>
          </Select>
        </FormItem>
        <FormItem label="问题子类" prop="sonType">
          <Select v-model="form.sonType" placeholder="请选择转接目标问题子类">
            <Option v-for="item in workSheetTypeListSon" :key="item.id" :value="item.id" :label="item.type_name"></Option>
          </Select>
        </FormItem>
        <FormItem label="截止日期" prop="deadline">
          <DatePicker v-model="form.deadline"  type="date" style="width:100%;" format="yyyy-MM-dd"></DatePicker>
        </FormItem>
        <FormItem label="回复" prop="message">
          <Input type="textarea" v-model="form.message" placeholder="回复提交人（可选）" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button :loading="submitLoading" type="primary" @click="ok">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { GetALLWorkSheetType, GetALLWorkSheetTypeSon } from '@/api/logistics/type'
import { GetWSAllUser, ReceiveApi } from '@/api/logistics/worksheet'
import dayjs from 'dayjs'
import eventVue from './event.js'

export default {
  name: 'appoint-accept',
  data () {
    return {
      appointModal: false,
      submitLoading: false,
      form: {
        id: '',
        type: '',
        sonType: '',
        deadline: '',
        message: ''
      },
      workSheetTypeList: [],
      workSheetTypeListSon: [],
      userList: []
    }
  },
  created: function () {
    this.getWorkSheetAllTypeList()
  },
  methods: {
    ok () {
      this.submitLoading = true
      this.form.deadline = this.form.deadline === '' ? '' : dayjs(this.form.deadline).format('YYYY-MM-DD')
      ReceiveApi(this.form).then(res => {
        const result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '操作成功！'
          })
          eventVue.$emit('myFun', {})
          this.cancelModal()
          this.appointModal = false
        } else {
          this.$Notice.error({
            title: '操作失败',
            desc: result.msg
          })
        }
        this.submitLoading = false
      }).catch(_ => {
        this.submitLoading = false
      })
    },
    cancelModal () {
      this.form.type = ''
      this.form.sonType = ''
      this.userList = []
    },
    show (id, type) {
      this.form.id = id
      if (type) {
        this.form.type = type.id
        this.getWorkSheetAllTypeListSon(this.form.type)
      }
      this.appointModal = true
    },
    getWorkSheetAllTypeList () {
      GetALLWorkSheetType().then(res => {
        this.workSheetTypeList = res.data
      })
    },
    getWorkSheetAllTypeListSon (typeId) {
      this.workSheetTypeListSon = []
      this.form.sonType = ''
      let params = {
        parent_id: typeId
      }
      GetALLWorkSheetTypeSon(params).then(res => {
        this.workSheetTypeListSon = res.data
      })
    },
    handleTypeOnChange (typeId) {
      // 取到用户
      // this.getUserList(typeId)
      // 取当前大类的子类
      this.getWorkSheetAllTypeListSon(typeId)
    },
    getUserList (typeId) {
      this.userList = []
      if (typeId) {
        const params = {
          ws_type__id: typeId
        }
        GetWSAllUser(params).then(res => {
          this.userList = res.data
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
